module.exports = "<div *ngIf=\"loading|async\" class=\"overlay\">\r\n  <!-- md-spinner is short for <md-progress-circle mode=\"indeterminate\"></md-progress-circle> -->\r\n  <div class=\"overlay-loader\"></div>\r\n</div>\r\n\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main